import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

export const JioPayChicmicStrip = () => {
  return (
    <Svg data-name="JioPay Strip" width={'100%'} height={47.277}>
      <Defs>
        <ClipPath id="prefix__a">
          <Path data-name="Path 943" d="M0-78.723h292.591V-126H0z" transform="translate(0 126)" fill="#006fb6" />
        </ClipPath>
      </Defs>
      <G data-name="Group 3404" clipPath="url(#prefix__a)">
        <G data-name="Group 3239">
          <Path
            data-name="Path 778"
            d="M73.629 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3240">
          <Path
            data-name="Path 779"
            d="M82.384 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3241">
          <Path
            data-name="Path 780"
            d="M91.139 1.751a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751A1.751 1.751 0 0189.388 0a1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3242">
          <Path
            data-name="Path 781"
            d="M99.894 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.75-1.751 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3243">
          <Path
            data-name="Path 782"
            d="M108.649 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01106.898 0a1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3244">
          <Path
            data-name="Path 783"
            d="M117.404 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01115.653 0a1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3245">
          <Path
            data-name="Path 784"
            d="M117.404 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3246">
          <Path
            data-name="Path 785"
            d="M73.629 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3247">
          <Path
            data-name="Path 786"
            d="M91.139 19.261a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3248">
          <Path
            data-name="Path 787"
            d="M99.894 19.261a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.75-1.751 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3249">
          <Path
            data-name="Path 788"
            d="M108.649 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3250">
          <Path
            data-name="Path 789"
            d="M73.629 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3251">
          <Path
            data-name="Path 790"
            d="M82.384 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3252">
          <Path
            data-name="Path 791"
            d="M108.649 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3253">
          <Path
            data-name="Path 792"
            d="M73.629 36.771a1.751 1.751 0 01-1.75 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3254">
          <Path
            data-name="Path 793"
            d="M82.384 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3255">
          <Path
            data-name="Path 794"
            d="M91.139 36.771a1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.752-1.751 1.75 1.75 0 011.75 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3256">
          <Path
            data-name="Path 795"
            d="M99.894 36.771a1.75 1.75 0 01-1.75 1.751 1.75 1.75 0 01-1.75-1.75 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.75 1.749z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3257">
          <Path
            data-name="Path 796"
            d="M108.649 36.771a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3258">
          <Path
            data-name="Path 797"
            d="M117.404 36.771a1.751 1.751 0 01-1.75 1.751 1.75 1.75 0 01-1.751-1.75 1.75 1.75 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3259">
          <Path
            data-name="Path 798"
            d="M73.629 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3260">
          <Path
            data-name="Path 799"
            d="M91.139 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.752-1.751 1.751 1.751 0 011.75 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3261">
          <Path
            data-name="Path 800"
            d="M99.894 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.75-1.75 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.751 1.75"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3262">
          <Path
            data-name="Path 801"
            d="M108.649 45.526a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3263">
          <Path
            data-name="Path 802"
            d="M117.404 45.526a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3264">
          <Path
            data-name="Path 803"
            d="M3.502 1.751a1.751 1.751 0 01-1.75 1.751A1.751 1.751 0 010 1.751 1.751 1.751 0 011.751 0a1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3265">
          <Path
            data-name="Path 804"
            d="M12.258 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.75-1.751 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3266">
          <Path
            data-name="Path 805"
            d="M21.012 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 0119.261 0a1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3267">
          <Path
            data-name="Path 806"
            d="M3.502 19.261a1.751 1.751 0 01-1.75 1.751A1.751 1.751 0 010 19.261a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3268">
          <Path
            data-name="Path 807"
            d="M12.258 19.261a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.75-1.751 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3269">
          <Path
            data-name="Path 808"
            d="M21.012 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3270">
          <Path
            data-name="Path 809"
            d="M21.012 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3271">
          <Path
            data-name="Path 810"
            d="M3.502 36.771a1.75 1.75 0 01-1.75 1.751A1.751 1.751 0 010 36.771a1.751 1.751 0 011.752-1.751 1.75 1.75 0 011.75 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3272">
          <Path
            data-name="Path 811"
            d="M12.258 36.771a1.75 1.75 0 01-1.75 1.751 1.75 1.75 0 01-1.75-1.75 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.75 1.749z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3273">
          <Path
            data-name="Path 812"
            d="M21.012 36.771a1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.75 1.75 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3274">
          <Path
            data-name="Path 813"
            d="M3.502 45.526a1.751 1.751 0 01-1.75 1.751A1.751 1.751 0 010 45.526a1.751 1.751 0 011.752-1.751 1.751 1.751 0 011.75 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3275">
          <Path
            data-name="Path 814"
            d="M12.258 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.75-1.75 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.751 1.75"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3276">
          <Path
            data-name="Path 815"
            d="M21.012 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3277">
          <Path
            data-name="Path 816"
            d="M56.076 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 0154.325 0a1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3278">
          <Path
            data-name="Path 817"
            d="M64.831 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 0163.08 0a1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3279">
          <Path
            data-name="Path 818"
            d="M56.076 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3280">
          <Path
            data-name="Path 819"
            d="M64.831 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3281">
          <Path
            data-name="Path 820"
            d="M64.831 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3282">
          <Path
            data-name="Path 821"
            d="M56.076 36.771a1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3283">
          <Path
            data-name="Path 822"
            d="M64.831 36.771a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3284">
          <Path
            data-name="Path 823"
            d="M64.831 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3285">
          <Path
            data-name="Path 824"
            d="M257.527 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3286">
          <Path
            data-name="Path 825"
            d="M266.282 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01264.531 0a1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3287">
          <Path
            data-name="Path 826"
            d="M266.282 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3288">
          <Path
            data-name="Path 827"
            d="M257.527 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3289">
          <Path
            data-name="Path 828"
            d="M257.527 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3290">
          <Path
            data-name="Path 829"
            d="M266.282 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3291">
          <Path
            data-name="Path 830"
            d="M257.527 36.771a1.751 1.751 0 01-1.75 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3292">
          <Path
            data-name="Path 831"
            d="M266.282 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3293">
          <Path
            data-name="Path 832"
            d="M257.527 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3294">
          <Path
            data-name="Path 833"
            d="M239.974 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01238.223 0a1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3295">
          <Path
            data-name="Path 834"
            d="M248.729 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01246.978 0a1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3296">
          <Path
            data-name="Path 835"
            d="M239.974 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3297">
          <Path
            data-name="Path 836"
            d="M222.42 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3298">
          <Path
            data-name="Path 837"
            d="M248.729 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3299">
          <Path
            data-name="Path 838"
            d="M248.729 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3300">
          <Path
            data-name="Path 839"
            d="M239.974 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3301">
          <Path
            data-name="Path 840"
            d="M248.729 36.771a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.75 1.75 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3302">
          <Path
            data-name="Path 841"
            d="M248.729 45.526a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3303">
          <Path
            data-name="Path 842"
            d="M35.02 36.771a1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.75 1.75 1.751 1.751 0 01-1.749 1.752 1.751 1.751 0 01-1.751-1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3304">
          <Path
            data-name="Path 843"
            d="M26.265 36.771a1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.75 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3305">
          <Path
            data-name="Path 844"
            d="M35.02 28.016a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3306">
          <Path
            data-name="Path 845"
            d="M35.02 19.261a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3307">
          <Path
            data-name="Path 846"
            d="M26.265 19.261a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3308">
          <Path
            data-name="Path 847"
            d="M35.02 10.506a1.751 1.751 0 011.75-1.751 1.75 1.75 0 011.75 1.75 1.751 1.751 0 01-1.749 1.752 1.751 1.751 0 01-1.751-1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3309">
          <Path
            data-name="Path 848"
            d="M26.265 10.506a1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.75 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3310">
          <Path
            data-name="Path 849"
            d="M43.819 45.526a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3311">
          <Path
            data-name="Path 850"
            d="M43.819 28.016a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3312">
          <Path
            data-name="Path 851"
            d="M43.819 19.261a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3313">
          <Path
            data-name="Path 852"
            d="M43.819 10.506a1.751 1.751 0 011.75-1.751 1.75 1.75 0 011.75 1.75 1.751 1.751 0 01-1.749 1.752 1.751 1.751 0 01-1.751-1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3314">
          <Path
            data-name="Path 853"
            d="M43.819 1.751A1.751 1.751 0 0145.57 0a1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3315">
          <Path
            data-name="Path 854"
            d="M178.689 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.75 1.75 0 01176.937 0a1.751 1.751 0 011.752 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3316">
          <Path
            data-name="Path 855"
            d="M178.689 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3317">
          <Path
            data-name="Path 856"
            d="M187.444 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01185.693 0a1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3318">
          <Path
            data-name="Path 857"
            d="M196.199 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3319">
          <Path
            data-name="Path 858"
            d="M204.954 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3320">
          <Path
            data-name="Path 859"
            d="M213.709 1.751a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751A1.751 1.751 0 01211.958 0a1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3321">
          <Path
            data-name="Path 860"
            d="M222.464 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01220.713 0a1.75 1.75 0 011.751 1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3322">
          <Path
            data-name="Path 861"
            d="M222.464 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3323">
          <Path
            data-name="Path 862"
            d="M187.444 36.771a1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3324">
          <Path
            data-name="Path 863"
            d="M196.199 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3325">
          <Path
            data-name="Path 864"
            d="M204.907 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3326">
          <Path
            data-name="Path 865"
            d="M213.709 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3327">
          <Path
            data-name="Path 866"
            d="M213.709 28.063a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3328">
          <Path
            data-name="Path 867"
            d="M213.709 19.354a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3329">
          <Path
            data-name="Path 868"
            d="M187.444 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3330">
          <Path
            data-name="Path 869"
            d="M204.954 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3331">
          <Path
            data-name="Path 870"
            d="M213.709 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.752-1.752 1.751 1.751 0 011.75 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3332">
          <Path
            data-name="Path 871"
            d="M222.464 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3333">
          <Path
            data-name="Path 872"
            d="M231.218 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01229.467 0a1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3334">
          <Path
            data-name="Path 873"
            d="M231.218 19.177a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3335">
          <Path
            data-name="Path 874"
            d="M231.218 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3336">
          <Path
            data-name="Path 875"
            d="M227.717 28.099a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.75-1.75z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3337">
          <Path
            data-name="Path 876"
            d="M231.218 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3338">
          <Path
            data-name="Path 877"
            d="M146.295 0a23.638 23.638 0 00-23.639 23.639 23.639 23.639 0 0023.639 23.638 23.639 23.639 0 0023.639-23.638A23.639 23.639 0 00146.295 0"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3339">
          <Path
            data-name="Path 878"
            d="M182.206 22.739a1.742 1.742 0 00.615-1.495 1.779 1.779 0 00-.6-1.475 3 3 0 00-1.886-.479h-2.345v3.908h2.306a3.194 3.194 0 001.905-.459m1.475-5.3a3.771 3.771 0 011.578 1.558 4.684 4.684 0 01.518 2.228 4.713 4.713 0 01-.527 2.257 3.754 3.754 0 01-1.583 1.553 5.388 5.388 0 01-2.58.567h-3.087v4.768h-3.068v-13.5h6.195a5.277 5.277 0 012.56.576"
            fill="#fff"
          />
        </G>
        <G data-name="Group 3340">
          <Path
            data-name="Path 879"
            d="M192.045 25.778a4.447 4.447 0 00-1.935.332 1.15 1.15 0 00-.665 1.114 1.243 1.243 0 00.42 1.025 1.758 1.758 0 001.143.342 2.439 2.439 0 001.123-.254 1.822 1.822 0 00.772-.733 2.312 2.312 0 00.276-1.161v-.664zm1.134-2.035a2.265 2.265 0 00-.381-1.456 1.634 1.634 0 00-1.319-.459 2.222 2.222 0 00-1.251.293 1.231 1.231 0 00-.508.919h-2.756a2.731 2.731 0 011.31-2.276 6.126 6.126 0 013.341-.792 4.77 4.77 0 013.293.958 3.9 3.9 0 011.046 3.013v6.429h-2.5l-.158-1.311h-.039a2.65 2.65 0 01-1.124 1.133 3.973 3.973 0 01-1.983.449 4.309 4.309 0 01-1.847-.371 2.729 2.729 0 01-1.221-1.095 3.342 3.342 0 01-.43-1.734 2.728 2.728 0 011.3-2.5 7.138 7.138 0 013.723-.8h1.5z"
            fill="#fff"
          />
        </G>
        <G data-name="Group 3341">
          <Path
            data-name="Path 880"
            d="M202.324 27.165h.039l2.111-6.9h2.875l-3.481 9.714a6.9 6.9 0 01-1.476 2.628 4.39 4.39 0 01-1.9 1.2 8 8 0 01-2.238.293v-2.303a3.761 3.761 0 001.69-.322 1.862 1.862 0 00.909-1.1l-3.654-10.1h2.951z"
            fill="#fff"
          />
        </G>
        <G data-name="Group 3342">
          <Path
            data-name="Path 881"
            d="M139.358 14.257h-.789c-1.495 0-2.312.843-2.312 2.53v8.138c0 2.094-.708 2.83-2.367 2.83a4.006 4.006 0 01-3.21-1.605 2.721 2.721 0 00-1.8 2.721c0 2.176 2.039 3.509 5.82 3.509 4.6 0 7.019-2.313 7.019-7.372v-8.221c0-1.687-.816-2.53-2.367-2.53m7.128 4.108h-.545c-1.332 0-2.339.625-2.339 2.53v8.7c0 1.931.98 2.53 2.394 2.53h.544c1.333 0 2.284-.654 2.284-2.53v-8.701c0-1.958-.924-2.53-2.339-2.53m-.3-6.31a2.432 2.432 0 00-2.747 2.449c0 1.523 1.088 2.475 2.829 2.475a2.438 2.438 0 002.749-2.475c0-1.523-1.088-2.449-2.829-2.449m11.496 6.171c-4.462 0-7.426 2.833-7.426 7.049 0 4.326 2.855 7.1 7.344 7.1 4.461 0 7.4-2.775 7.4-7.073.001-4.243-2.911-7.076-7.318-7.076m-.055 10.15a2.887 2.887 0 01-2.938-3.1 2.9 2.9 0 012.938-3.075 2.9 2.9 0 012.938 3.1 2.926 2.926 0 01-2.938 3.075"
            fill="#fff"
          />
        </G>
        <G data-name="Group 3343">
          <Path
            data-name="Path 882"
            d="M35.02 1.751A1.751 1.751 0 0136.771 0a1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3344">
          <Path
            data-name="Path 883"
            d="M271.535 45.526a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3345">
          <Path
            data-name="Path 884"
            d="M271.535 28.016a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3346">
          <Path
            data-name="Path 885"
            d="M271.535 10.506a1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.75 1.751 1.751 1.751 0 01-1.749 1.751 1.75 1.75 0 01-1.751-1.75z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3347">
          <Path
            data-name="Path 886"
            d="M292.591 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3348">
          <Path
            data-name="Path 887"
            d="M292.591 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3349">
          <Path
            data-name="Path 888"
            d="M292.591 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3350">
          <Path
            data-name="Path 889"
            d="M292.591 36.771a1.751 1.751 0 01-1.75 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3351">
          <Path
            data-name="Path 890"
            d="M283.792 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01282.041 0a1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3352">
          <Path
            data-name="Path 891"
            d="M73.629 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 0171.878 0a1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3353">
          <Path
            data-name="Path 892"
            d="M82.384 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 0180.633 0a1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3354">
          <Path
            data-name="Path 893"
            d="M91.139 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3355">
          <Path
            data-name="Path 894"
            d="M99.894 1.751a1.751 1.751 0 01-1.752 1.751 1.751 1.751 0 01-1.75-1.751A1.75 1.75 0 0198.142 0a1.751 1.751 0 011.752 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3356">
          <Path
            data-name="Path 895"
            d="M108.649 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3357">
          <Path
            data-name="Path 896"
            d="M82.384 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3358">
          <Path
            data-name="Path 897"
            d="M117.404 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3359">
          <Path
            data-name="Path 898"
            d="M91.139 28.016a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3360">
          <Path
            data-name="Path 899"
            d="M99.894 28.016a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.75-1.751 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3361">
          <Path
            data-name="Path 900"
            d="M117.404 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3362">
          <Path
            data-name="Path 901"
            d="M82.384 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3363">
          <Path
            data-name="Path 902"
            d="M3.502 10.506a1.751 1.751 0 01-1.75 1.751A1.751 1.751 0 010 10.507a1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3364">
          <Path
            data-name="Path 903"
            d="M12.258 1.751a1.751 1.751 0 01-1.752 1.751 1.751 1.751 0 01-1.75-1.751A1.75 1.75 0 0110.506 0a1.751 1.751 0 011.752 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3365">
          <Path
            data-name="Path 904"
            d="M21.012 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3366">
          <Path
            data-name="Path 905"
            d="M3.502 28.016a1.751 1.751 0 01-1.75 1.751A1.751 1.751 0 010 28.016a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3367">
          <Path
            data-name="Path 906"
            d="M12.258 28.016a1.751 1.751 0 01-1.751 1.751 1.75 1.75 0 01-1.75-1.751 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3368">
          <Path
            data-name="Path 907"
            d="M56.076 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.752 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3369">
          <Path
            data-name="Path 908"
            d="M64.831 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3370">
          <Path
            data-name="Path 909"
            d="M56.076 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3371">
          <Path
            data-name="Path 910"
            d="M56.076 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3372">
          <Path
            data-name="Path 911"
            d="M257.527 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01255.776 0a1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3373">
          <Path
            data-name="Path 912"
            d="M266.282 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3374">
          <Path
            data-name="Path 913"
            d="M266.282 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3375">
          <Path
            data-name="Path 914"
            d="M239.974 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.75-1.751 1.751 1.751 0 011.752 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3376">
          <Path
            data-name="Path 915"
            d="M248.729 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3377">
          <Path
            data-name="Path 916"
            d="M239.974 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3378">
          <Path
            data-name="Path 917"
            d="M222.42 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3379">
          <Path
            data-name="Path 918"
            d="M239.974 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3380">
          <Path
            data-name="Path 919"
            d="M35.02 45.526a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3381">
          <Path
            data-name="Path 920"
            d="M26.265 45.526a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3382">
          <Path
            data-name="Path 921"
            d="M26.265 28.016a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3383">
          <Path
            data-name="Path 922"
            d="M26.265 1.751A1.751 1.751 0 0128.016 0a1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3384">
          <Path
            data-name="Path 923"
            d="M43.819 36.771a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3385">
          <Path
            data-name="Path 924"
            d="M187.444 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3386">
          <Path
            data-name="Path 925"
            d="M196.199 1.751a1.751 1.751 0 01-1.751 1.751 1.752 1.752 0 01-1.751-1.751A1.751 1.751 0 01194.448 0a1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3387">
          <Path
            data-name="Path 926"
            d="M204.954 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01203.203 0a1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3388">
          <Path
            data-name="Path 927"
            d="M213.709 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3389">
          <Path
            data-name="Path 928"
            d="M178.689 36.771a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.751-1.75 1.75 1.75 0 011.75-1.751 1.751 1.751 0 011.751 1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3390">
          <Path
            data-name="Path 929"
            d="M222.464 36.771a1.75 1.75 0 01-1.75 1.751 1.75 1.75 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3391">
          <Path
            data-name="Path 930"
            d="M178.689 45.526a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3392">
          <Path
            data-name="Path 931"
            d="M196.199 45.526a1.751 1.751 0 01-1.75 1.751 1.752 1.752 0 01-1.752-1.751 1.752 1.752 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3393">
          <Path
            data-name="Path 932"
            d="M231.218 10.506a1.751 1.751 0 01-1.75 1.751 1.751 1.751 0 01-1.752-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3394">
          <Path
            data-name="Path 933"
            d="M271.535 36.771a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.75-1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3395">
          <Path
            data-name="Path 934"
            d="M271.535 19.261a1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3396">
          <Path
            data-name="Path 935"
            d="M271.535 1.751A1.751 1.751 0 01273.286 0a1.751 1.751 0 011.749 1.751 1.751 1.751 0 01-1.749 1.751 1.751 1.751 0 01-1.751-1.751"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3397">
          <Path
            data-name="Path 936"
            d="M292.591 1.751a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751A1.751 1.751 0 01290.84 0a1.751 1.751 0 011.751 1.751z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3398">
          <Path
            data-name="Path 937"
            d="M283.792 10.506a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.75 1.75 0 011.751 1.75z"
            fill="#006fb6"
          />
        </G>
        <G data-name="Group 3399">
          <Path
            data-name="Path 938"
            d="M283.792 19.261a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#f5aa21"
          />
        </G>
        <G data-name="Group 3400">
          <Path
            data-name="Path 939"
            d="M283.792 28.016a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3401">
          <Path
            data-name="Path 940"
            d="M283.792 36.771a1.75 1.75 0 01-1.75 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.75-1.752 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
        <G data-name="Group 3402">
          <Path
            data-name="Path 941"
            d="M283.792 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.75 1.751 1.751 0 011.751-1.752 1.751 1.751 0 011.751 1.751"
            fill="#3bb5ea"
          />
        </G>
        <G data-name="Group 3403">
          <Path
            data-name="Path 942"
            d="M292.591 45.526a1.751 1.751 0 01-1.751 1.751 1.751 1.751 0 01-1.751-1.751 1.751 1.751 0 011.751-1.751 1.751 1.751 0 011.751 1.751"
            fill="#4fbbab"
          />
        </G>
      </G>
    </Svg>
  )
}

export default JioPayChicmicStrip
